import { z } from "zod";
import { ApiDefaultSchema } from "~/api/types";

export const UserSchemaUserStatsStandardRoundStats = z.object({
  Won: z.number().nullish(),
  Iterations: z.number().nullish(),
  RawStd: z.number().nullish(),
  PreviousRawStd: z.number().nullish(),
  PreviousAverage: z.number().nullish(),
  TotalTurnsToSolve: z.number().nullish(),
  MinTurnsToSolve: z.number().nullish(),
  MaxTurnsToSolve: z.number().nullish(),
  AverageTurnsToSolve: z.number().nullish(),
  Average: z.number().nullish(),
  Variance: z.number().nullish(),
  Std: z.number().nullish(),
});

export const UserSchemaUserStatsStats = z.object({
  PrizePlans: z.number().nullish(),
  "TournamentPrize.Diamonds": z.number().nullish(),
  "PrizeBox.TimedClaimed.LetterCrate_358": z.number().nullish(),
  "TnT.FourToFortune.PlayedShow": z.number().nullish(),
  TournamentMoney: z.number().nullish(),
  "CategoryFamily.Television": z.number().nullish(),
  "TournamentPrize.VF.GoldI": z.number().nullish(),
  TotalMoney: z.number().nullish(),
  "Show.LandOnFreePlay": z.number().nullish(),
  Collectible: z.number().nullish(),
  "EventCollectibles.All.GiftBox": z.number().nullish(),
  "GiftBox.Open.GiftBox.Bronze": z.number().nullish(),
  "TnT.QuickDraw.WonRoundsPerShow.7": z.number().nullish(),
  "Show.BuyVowel": z.number().nullish(),
  "TnT.QuickDraw.WonRoundsPerShow.8": z.number().nullish(),
  "ReachLocation.134": z.number().nullish(),
  "TnT.QuickDraw.WonRoundsPerShow.5": z.number().nullish(),
  "TnT.QuickDraw.WonRoundsPerShow.6": z.number().nullish(),
  "TnT.QuickDraw.WonRoundsPerShow.9": z.number().nullish(),
  "CategoryFamily.AROUNDTHEHOUSE": z.number().nullish(),
  "TnT.QuickDraw.WonRoundsPerShow.3": z.number().nullish(),
  "TnT.QuickDraw.WonRoundsPerShow.4": z.number().nullish(),
  "TnT.QuickDraw.WonRoundsPerShow.1": z.number().nullish(),
  "TnT.QuickDraw.WonRoundsPerShow.2": z.number().nullish(),
  "Diamonds.Total": z.number().nullish(),
  "TnT.ClassicTournament.WonShow": z.number().nullish(),
  "Show.SuperLetterGuessedCorrect.Total": z.number().nullish(),
  "CategoryFamily.Questions": z.number().nullish(),
  "CategoryFamily.Events": z.number().nullish(),
  "EventCollectibles.EC.july4th_2020_4.GiftBox": z.number().nullish(),
  VanityFramesCategoryOwned: z.number().nullish(),
  EnterTournament: z.number().nullish(),
  "TnT.QuickDraw.WonRound": z.number().nullish(),
  "Show.HintUsed": z.number().nullish(),
  TotalScore: z.number().nullish(),
  "TurnBased.Start": z.number().nullish(),
  "TournamentPrize.SpinUpgradeToken": z.number().nullish(),
  "TurnBased.Play": z.number().nullish(),
  LowScore: z.number().nullish(),
  "GiftBox.Open.Silver": z.number().nullish(),
  "Show.Correct.R": z.number().nullish(),
  "ReachLocation.7": z.number().nullish(),
  "TournamentPrize.VF.SilverI": z.number().nullish(),
  "ReachLocation.16": z.number().nullish(),
  "TnT.FourToFortune.BigWordScore": z.number().nullish(),
  "TurnBased.HintsUsed": z.number().nullish(),
  "Show.Correct.N": z.number().nullish(),
  "GiftBox.Open.GiftBox.july4th2018_crate": z.number().nullish(),
  "Show.Correct.L": z.number().nullish(),
  "Show.Correct.K": z.number().nullish(),
  "GiftBox.Open.Bronze": z.number().nullish(),
  "Show.Correct.G": z.number().nullish(),
  "Show.Correct.C": z.number().nullish(),
  "Show.Correct.A": z.number().nullish(),
  "ReachLocation.1": z.number().nullish(),
  "Show.BuyVowel.Tournament": z.number().nullish(),
  "EventCollectibles.All": z.number().nullish(),
  DailyAchievementsCompleted: z.number().nullish(),
  "CategoryFamily.BEFORE_AFTER": z.number().nullish(),
  "TournamentPrize.VF.SilverII": z.number().nullish(),
  "TournamentPrize.VF.SilverIII": z.number().nullish(),
  "GiftBox.Open.Gold": z.number().nullish(),
  HighScore: z.number().nullish(),
  CraftingRecipesRedeemed: z.number().nullish(),
  TotalLetters: z.number().nullish(),
  "Show.LuckyLetterGuessedCorrect.All": z.number().nullish(),
  "Show.LetterGuessed": z.number().nullish(),
  "TournamentPrize.HelpingHand": z.number().nullish(),
  "Show.BuyVowelCorrect.WorldTour": z.number().nullish(),
  "TurnBased.SocialMatch": z.number().nullish(),
  "CategoryFamily.Music": z.number().nullish(),
  BestFastPlayRank: z.number().nullish(),
  VanityFrameWinTournament: z.number().nullish(),
  "TournamentPrize.VF.BronzeII": z.number().nullish(),
  RoundHighScore: z.number().nullish(),
  "FastPlayPrize.Diamonds": z.number().nullish(),
  "TournamentPrize.VF.DiamondII": z.number().nullish(),
  "EventCollectibles.EC.fairy_tale_3": z.number().nullish(),
  "EventCollectibles.EC.fairy_tale_2": z.number().nullish(),
  "EventCollectibles.EC.fairy_tale_1": z.number().nullish(),
  StandardRoundCompleted: z.number().nullish(),
  StandardRoundTurnsToSolve: z.number().nullish(),
  "StandardRoundWon.SingleShot": z.number().nullish(),
  "Show.Stars.LuckyLetter": z.number().nullish(),
  "GiftBox.Open.GiftBox.july4th2018_flag": z.number().nullish(),
  "EventCollectibles.EC.july4th_2020_2.GiftBox": z.number().nullish(),
  "Show.Stars.All": z.number().nullish(),
  BonusRoundWon: z.number().nullish(),
  "TurnBased.Tie": z.number().nullish(),
  "TournamentPrize.Token.LuckyCoin": z.number().nullish(),
  "TurnBased.TurnsTaken": z.number().nullish(),
  "TournamentPrize.VF.GoldII": z.number().nullish(),
  "EventCollectibles.EC.fairy_tale_3.GiftBox": z.number().nullish(),
  "TnT.TournamentMultiplier.1.Entered": z.number().nullish(),
  "TournamentPrize.VF.GoldIII": z.number().nullish(),
  "RedeemCollection.134": z.number().nullish(),
  "TnT.FourToFortune.WonPerfectScore": z.number().nullish(),
  "Show.LoseATurn": z.number().nullish(),
  "Show.BuyVowelCorrect.Pvp": z.number().nullish(),
  "CategoryFamily.Things": z.number().nullish(),
  FastPlaysCompleted: z.number().nullish(),
  "TnT.TournamentMultiplier.5.Entered": z.number().nullish(),
  "Show.Stars.SolvePuzzle": z.number().nullish(),
  "RedeemCollection.7": z.number().nullish(),
  "Show.LuckyLetterGuessedCorrect.002": z.number().nullish(),
  "Show.Guess.A": z.number().nullish(),
  ShowsCompleted: z.number().nullish(),
  "Show.Guess.B": z.number().nullish(),
  "Show.Guess.C": z.number().nullish(),
  "TurnBased.GoldenHintsUsed": z.number().nullish(),
  "Show.BuyVowel.FastPlay": z.number().nullish(),
  "Show.LandOnBankrupt": z.number().nullish(),
  "TnT.QuickDraw.PlayedShow": z.number().nullish(),
  StandardRoundWon: z.number().nullish(),
  "Show.SolvePuzzle": z.number().nullish(),
  "TnT.PassiveTournaments.PointsEarned": z.number().nullish(),
  "CategoryFamily.Phrases": z.number().nullish(),
  "Show.BuyVowelCorrect.FastPlay": z.number().nullish(),
  VanityFrame: z.number().nullish(),
  "TnT.All.PlayedShow": z.number().nullish(),
  ShowsWon: z.number().nullish(),
  "Show.LetterGuessedCorrect": z.number().nullish(),
  "TournamentPrize.VowelDetector": z.number().nullish(),
  RoundTotalScore: z.number().nullish(),
  BonusRoundCompleted: z.number().nullish(),
  "GiftBox.Open.GiftBox.fairytale_tome": z.number().nullish(),
  "Show.10KCorrect": z.number().nullish(),
  "CategoryFamily.Entertainment": z.number().nullish(),
  "TurnBased.Win": z.number().nullish(),
  "CategoryFamily.Geography": z.number().nullish(),
  EnterPremiumTournament: z.number().nullish(),
  "Show.HintUsedCorrect": z.number().nullish(),
  "Show.SuperLetterGuessedCorrect.002": z.number().nullish(),
  "Show.SuperLetterGuessedCorrect.001": z.number().nullish(),
  "TournamentPrize.VF.BronzeI": z.number().nullish(),
  DailysComplete: z.number().nullish(),
  "CategoryFamily.LivingThings": z.number().nullish(),
  "Show.10K": z.number().nullish(),
  "TurnBased.Start.VanityFrame": z.number().nullish(),
  "Show.BuyVowelCorrect": z.number().nullish(),
  "TnT.ClassicTournament.PlayedShow": z.number().nullish(),
  "EventCollectibles.EC.fairy_tale_1.GiftBox": z.number().nullish(),
  "TnT.QuickDraw.WonRoundsPerShow.10": z.number().nullish(),
  "TnT.QuickDraw.WonRoundsPerShow.11": z.number().nullish(),
  "TnT.QuickDraw.WonRoundsPerShow.12": z.number().nullish(),
  "Show.GoldenHintUsed": z.number().nullish(),
  "TnT.QuickDraw.WonPerfectScore": z.number().nullish(),
  "Show.WinBonusRound": z.number().nullish(),
  "CategoryFamily.Movies": z.number().nullish(),
  "Show.SpinWheel": z.number().nullish(),
  "Show.BuyVowel.Pvp": z.number().nullish(),
  EnteredDailyOrFastPlayTournament: z.number().nullish(),
  LastStreakLevelCompletedCount: z.number().nullish(),
  WinTournament: z.number().nullish(),
  TournamentPuzzleCompleted: z.number().nullish(),
  "TnT.FourToFortune.WonRoundsPerShow.1": z.number().nullish(),
  "CategoryFamily.Culinary": z.number().nullish(),
  "TnT.FourToFortune.WonRoundsPerShow.3": z.number().nullish(),
  "TnT.FourToFortune.VeryLastMinuteScore": z.number().nullish(),
  "TnT.FourToFortune.WonRoundsPerShow.2": z.number().nullish(),
  "GiftBox.Open.GiftBox.fairytale_vine": z.number().nullish(),
  "TnT.FourToFortune.WonRoundsPerShow.5": z.number().nullish(),
  "TnT.FourToFortune.WonRoundsPerShow.4": z.number().nullish(),
  "TnT.FourToFortune.WonRoundsPerShow.7": z.number().nullish(),
  "TnT.FourToFortune.WonRoundsPerShow.6": z.number().nullish(),
  "Show.Stars.CashMeter": z.number().nullish(),
  "TnT.FourToFortune.WonRoundsPerShow.8": z.number().nullish(),
  "CategoryFamily.Characters": z.number().nullish(),
  Ties: z.number().nullish(),
  "Show.CashMeter": z.number().nullish(),
  "EventCollectibles.EC.fairy_tale_2.GiftBox": z.number().nullish(),
  "TournamentPrize.VF.DiamondI": z.number().nullish(),
  "Show.DailyWinStreak": z.number().nullish(),
  RedeemCollection: z.number().nullish(),
  "CategoryFamily.People": z.number().nullish(),
  "ShowsCompleted.": z.number().nullish(),
  "TournamentPrize.Letter.Z": z.number().nullish(),
  "StandardRoundWon.TotalGuesses.000": z.number().nullish(),
  "Show.StandardRoundWon.StarsEarned.2": z.number().nullish(),
  "Show.BuyVowelCorrect.Tournament": z.number().nullish(),
  "TnT.FourToFortune.WonRound": z.number().nullish(),
  "StandardRoundWon.TotalGuesses.004": z.number().nullish(),
  "Show.StandardRoundWon.StarsEarned.3": z.number().nullish(),
  "StandardRoundWon.TotalGuesses.003": z.number().nullish(),
  GamesPlayed: z.number().nullish(),
  "StandardRoundWon.TotalGuesses.002": z.number().nullish(),
  "StandardRoundWon.TotalGuesses.001": z.number().nullish(),
  "TournamentPrize.Letter.K": z.number().nullish(),
  "TournamentPrize.VF.DiamondIII": z.number().nullish(),
  "CategoryFamily.ProperNames": z.number().nullish(),
  "CategoryFamily.Same": z.number().nullish(),
  RoundLowScore: z.number().nullish(),
  "Show.Guess.P": z.number().nullish(),
  "CategoryFamily.Places": z.number().nullish(),
  "TnT.QuickDraw.VeryLastMinuteScore": z.number().nullish(),
  "Show.Guess.R": z.number().nullish(),
  "Show.Guess.U": z.number().nullish(),
  "Show.BuyVowel.TournamentOrFastPlay": z.number().nullish(),
  RoundsPlayed: z.number().nullish(),
  "Show.Guess.G": z.number().nullish(),
  "Show.Guess.K": z.number().nullish(),
  "Show.Guess.L": z.number().nullish(),
  "Show.Guess.M": z.number().nullish(),
  "TnT.QuickDraw.BigWordScore": z.number().nullish(),
  "Show.Guess.N": z.number().nullish(),
  "RedeemCollection.1": z.number().nullish(),
  "TournamentPrize.VF.BronzeIII": z.number().nullish(),
  "Show.Guess.Y": z.number().nullish(),
  "Show.BuyVowel.WorldTour": z.number().nullish(),
  "Show.BuyVowelCorrect.TournamentOrFastPlay": z.number().nullish(),
  "Show.PlayBonusRound": z.number().nullish(),
  "EventCollectibles.EC.july4th_2020_4": z.number().nullish(),
  "Show.GoldenHintUsedCorrect": z.number().nullish(),
  "EventCollectibles.EC.july4th_2020_2": z.number().nullish(),
  Version: z.number().nullish(),
  "GiftBox.Open.All": z.number().nullish(),
  TotalShowsCompleted: z.number().nullish(),
  PlaceInTournament: z.number().nullish(),
});

export const UserSchemaUserStats = z.object({
  Stats: UserSchemaUserStatsStats,
  StandardRoundStats: UserSchemaUserStatsStandardRoundStats,
});

export const UserSchemaPlayer = z.object({
  Money: z.number().nullish(),
  UserId: z.number().nullish(),
  Name: z.string(),
  DisplayName: z.string(),
  PictureUrl: z.string().nullish(),
  Level: z.number(),
  PlayerType: z.number().nullish(),
  VanityItems: z.object({
    VanityFrameCommodityKey: z.string().nullish(),
    AvatarKey: z.string().nullish(),
  }),
  Traits: z.string().nullish(),
  WorldTourLeagueBadgeV2: z.string().nullish(),
  HeadToHeadMetaRank: z.number().nullish(),
  Club: z.object({
    Id: z.string().nullish(),
    Name: z.string().nullish(),
    Type: z.number().nullish(),
    Image: z.string().nullish(),
    Role: z.number().nullish(),
  }),
  GlickoRank: z.number().nullish(),
  GlickoRatingDeviation: z.number().nullish(),
  GlickoWinStreak: z.number().nullish(),
  FeatureUnlock: z.string().array(),
  WinnerOfTheDayCounts: z.number().nullish(),
  AllStarsFinalistCounts: z.number().nullish(),
  CachedProfilePicture: z.string().nullish(),
});

export const UserSchema = ApiDefaultSchema.extend({
  Data: z.object({
    UserStats: UserSchemaUserStats,
    UserDailyStats: z.string().nullish(),
    Player: UserSchemaPlayer,
    NumFriends: z.number().nullish(),
    FriendRequestStatus: z.string().nullish(),
  }),
});

export type TUser = z.infer<typeof UserSchema>;
